import {Component, Input} from '@angular/core';
import {NavItem} from 'src/app/interfaces/nav-item';

@Component({
    selector: 'app-navbar-drop',
    templateUrl: './navbar-drop.component.html',
    styleUrls: ['./navbar-drop.component.scss'],
    standalone: false
})
export class NavbarDropComponent {
  @Input() props: NavItem;

  public mainUrl(url: string): string {
    if(!url) return "";
    if(!url.startsWith('/')) url= '/' + url;
    return url.split('?')[0];
  }

  public queryUrl(url): {[key: string]: any} {
    if(!url) return null;
    const queryUrl = url.split('?')[1];
    return queryUrl ? queryUrl.split('&').reduce((a, b) => {
      const queryParam = b.split('=');
      a[queryParam[0]] = queryParam[1];
      return a;
    }, {}) : null;
  }
}
